module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Did you like the service?","letsShare":"Share with friends, help project"},"ru":{"title":"Понравился ли Вам сервис?","letsShare":"Поделитесь с друзьями, помогите проекту"}}')
  delete Component.options._Ctor
}
